import React, { useState } from "react";
import ToolbarButton from "components/ToolbarButton";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import FavoriteIcon from "@material-ui/icons/Favorite";
import { useStoreon } from "storeon/react";

import { updateFavoriteDesign } from "api";

const Favorites = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const {
    dispatch,
    proboCodes,
    product,
    canvas,
    contentId,
    contentType,
  } = useStoreon("canvas", "product", "contentId", "contentType", "proboCodes");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDesignSave = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const canvasData = canvas.DPE.persistent.toBase64();
      const resp = await updateFavoriteDesign(
        contentId,
        canvasData,
        product?.id,
        proboCodes
      );
      if (!resp.designId) {
        throw new Error("Invalid design ID");
      }
      dispatch("content/setType/favorite");
      dispatch("content/setId", resp.designId);
      dispatch("notification/success", "Favorite desing saved!");
    } catch (err) {
      dispatch("notification/error", {
        text: "Can't save favorite design",
        err,
      });
    }
    setIsLoading(false);
    setAnchorEl(null);
  };

  if (!window.DeskpadData.nonce) {
    return null;
  }

  //FIXME: get user account from backend
  return (
    <React.Fragment>
      <ToolbarButton
        dark
        active={Boolean(anchorEl)}
        onClick={handleClick}
        vertical
        isLoading={isLoading}
        icon={<FavoriteIcon style={{ fontSize: 27 }} />}
      />
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleDesignSave}>Save to favorites</MenuItem>
        <MenuItem
          onClick={() => {
            window.location.href = "/mein-konto/dpe_my_designs/";
          }}
        >
          My favorites
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
};

export default Favorites;
